import React, { useEffect } from "react";
import { Link } from "react-router-dom";

export default function CookieNotice({ open, onOk }) {
    useEffect(() => {
        if (!open) return;

        // lock scroll όσο φαίνεται (προαιρετικό – μπορείς να το σβήσεις)
        const prev = document.body.style.overflow;
        document.body.style.overflow = "hidden";
        return () => {
            document.body.style.overflow = prev || "auto";
        };
    }, [open]);

    if (!open) return null;

    return (
        <div className="fixed inset-0 z-[9999] flex items-end justify-center">
            {/* overlay */}
            <div className="absolute inset-0 bg-black/40" />

            {/* notice */}
            <div className="relative z-10 mb-6 w-[95%] max-w-3xl rounded-2xl bg-white shadow-xl">
                <div className="flex flex-col gap-4 p-6 sm:flex-row sm:items-center sm:justify-between">
                    <p className="text-sm leading-6 text-gray-700">
                        Χρησιμοποιούμε cookies για τη βελτίωση της εμπειρίας σας και για στατιστικούς σκοπούς.
                        Συνεχίζοντας την περιήγηση, αποδέχεστε τη χρήση cookies καθως και τους όρους χρήσης.
                        {" "}
                        <Link
                            to="/terms"
                            className="ml-1 underline text-custom-green"
                            target="_blank"
                            rel="noreferrer"
                        >
                            Μάθετε περισσότερα
                        </Link>
                    </p>

                    <button
                        onClick={onOk}
                        className="shrink-0 rounded-xl bg-custom-green px-5 py-2 text-sm font-medium text-white hover:opacity-90"
                    >
                        OK
                    </button>
                </div>
            </div>
        </div>
    );
}
